import { httpClient } from "@/services";

export default {
	state: {
		scheduleEmployeesList: {
			week1: {},
			week2: {},
			week3: {},
			week4: {},
		},
		scheduleEmployees: null,
		scheduleWeeks: null,

	},
	mutations: {
		updateEmployeeWorkSchedule(state, { employees, scheduleEmployees, weeks }) {
			state.scheduleEmployeesList = {
				week1: {},
				week2: {},
				week3: {},
				week4: {},
			};

			let iteration = 0;
			let numberWeek = 1;

			for (const item in scheduleEmployees) {
				iteration++;
				if (iteration === 8) {
					numberWeek++;
					iteration = 1;
				}

				Object.assign(state.scheduleEmployeesList[`week${ numberWeek }`], {
					[item]: scheduleEmployees[item],
				});
			}

			state.scheduleEmployees = employees;
			state.scheduleWeeks = weeks;
		}
	},
	actions: {
		async getEmployeeWorkSchedule({ commit }) {
			try {
				const { data } = await httpClient.get('employee-work-schedule');
				if (data && !data.status) {
					commit('updateEmployeeWorkSchedule', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getEmployeeWorkScheduleTab({ commit }, date_start) {
			try {
				const { data } = await httpClient.post('employee-work-schedule/list', { date_start });
				if (data && !data.status) {
					commit('updateEmployeeWorkSchedule', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getScheduleEmployee(ctx, { day, schedule }) {
			try {
				const { data } = await httpClient.get(`employee-work-schedule/edit/${ day }/${ schedule }`);
				if (data) return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onScheduleEmployeeSave({ dispatch, state }, { tab, day, schedule, employeeSelected }) {
			try {
				const { data } = await httpClient.post(
					`employee-work-schedule/update/${ day }/${ schedule }`,
					{ employeeSelected }
				);

				if (data && data.status) {
					const date_start = state.scheduleWeeks[tab]["date_start"];
					await dispatch('getEmployeeWorkScheduleTab', date_start);
					dispatch('setAlert', { type: "success", message: "Editing Saved Successfully" });
				}
			} catch (e) {
				console.error(e);
			}
		}
	},
	getters: {
		scheduleEmployeesList: s => s.scheduleEmployeesList,
		scheduleEmployees: s => s.scheduleEmployees,
		scheduleWeeks: s => s.scheduleWeeks
	}
};
